
import React from 'react';
import { Navigate } from 'react-router-dom';

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

const Protected2FARoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const token = localStorage.getItem('jwtToken');
  // Check per-user 2FA verification
  const userEmail = localStorage.getItem('userEmail')?.toLowerCase();
  const is2FAVerified = userEmail
    ? localStorage.getItem(`is2FAVerified_${userEmail}`) === 'true'
    : false;

  if (!isLoggedIn || !token || isTokenExpired(token)) {
    // Not logged in or token expired
    return <Navigate to="/" replace />;
  }
  if (is2FAVerified) {
    // Already 2FA verified for this user
    return <Navigate to="/dashboard" replace />;
  }
  // Logged in, but not 2FA verified
  return children;
};

export default Protected2FARoute;
